export const isDocGatedAndDoesUserNotHaveAccess = (item, userGates) => {
  return item.gate && userGates && !userGates.includes(item.gate);
};